// extracted by mini-css-extract-plugin
module.exports = {"content":"_1D54qKM7","chev":"_1v7ngBQ9"};